import React, { useState } from "react";
import { Container, Card } from "react-bootstrap";
import { EntypoChevronDown } from "react-entypo-icons";
import "./faq.css"; // Optional CSS
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import { strings } from "../../localization";
import { withRouter } from "react-router-dom";
import { ORG_ID, TABLE_ID } from "../../config";

const faqData = [
  {
    category: "Servicio Delivery",
    faqs: [
      {
        question: "¿Hay un mínimo para pedir?",
        answer: "No hay pedido mínimo",
      },
      {
        question: "¿Se le da propina al motorista?",
        answer:
          "La propina es voluntaria, ya que el cargo por envío es en parte para el motorista",
      },
      {
        question: "¿Tienen costo de envío?",
        answer:
          "Si, el costo de envío es de $1500. independiente de la distancia en relación al local o cantidad comprada",
      },
      {
        question: "¿Cuánto demora el despacho a domicilio?",
        answer:
          "El despacho a domicilio puede demorar entre 50 y 120 minutos dependiendo la demanda",
      },
      {
        question: "¿Cuánto demora el retiro en local?",
        answer:
          "El retiro puede demorar entre 30 y 60 minutos dependiendo la demanda",
      },
      {
        question: "¿Cuál es el rango de despacho?",
        answer:
          "Revisar mapa en página de locales para conocer plan general. Llamar a locales para conocer la disponibilidad en puntos específicos.",
      },
      {
        question: "¿Dónde puedo hacer mis sugerencias o comentarios?",
        answer: "Puedes escribirnos a contacto@ebol.cl",
      },
    ],
  },
  {
    category: "Servicio en Local",
    faqs: [
      {
        question: "¿Reciben tarjeta junaeb?",
        answer:
          "No, ya que al tener patente de alcoholes en nuestros locales, estamos inhabilitados por ley para hacerlo.",
      },
    ],
  },
  {
    category: "Productos",
    faqs: [
      {
        question: "¿Cambian ingredientes de los platos?",
        answer:
          "Si, puedes cambiar los ingredientes que quieras. Debes solicitarlo al momento de hacer tu pedido. Algunos cambios están sujetos a costos asociados, pregunta al momento de solicitar tu cambio.",
      },
    ],
  },
];

const Faq = ({match, location}) => {
  const [openItems, setOpenItems] = useState([]); // List of open item keys

  const toggleItem = (key) => {
    setOpenItems((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  return (
    <div className="vh-100 overflow-auto pb-3">
      <Navbar pageName={strings.faqs}/>
      <Container className="py-4">
        {faqData.map((category, catIndex) => (
          <div key={catIndex} className="mb-4">
            <div className="p-2 mb-2">
              <h5 className="text-uppercase p-0 m-0 fw-bold">{category.category}</h5>
            </div>
            {category.faqs.map((faq, qIndex) => {
              const key = `${catIndex}-${qIndex}`;
              const isOpen = openItems.includes(key);
              return (
                <Card key={key} className="mb-2 shadow-sm">
                  <Card.Header
                    onClick={() => toggleItem(key)}
                    className="d-flex justify-content-between align-items-center faq-header px-3 py-3"
                    style={{ cursor: "pointer" }}
                  >
                    <span className="text-primary">{faq.question}</span>
                    <span
                      style={{
                        transition: "transform 0.3s ease",
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    >
                      <EntypoChevronDown />
                    </span>
                  </Card.Header>
                  {isOpen && <Card.Body className="px-3 py-2">{faq.answer}</Card.Body>}
                </Card>
              );
            })}
          </div>
        ))}
      </Container>
      <Footer />
    </div>
  );
};

export default withRouter(Faq);
